/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ReviewerScorecardStats } from './ReviewerScorecardStats.js';
import {
    ReviewerScorecardStatsFromJSON,
    ReviewerScorecardStatsFromJSONTyped,
    ReviewerScorecardStatsToJSON,
} from './ReviewerScorecardStats.js';

/**
 * 
 * @export
 * @interface GetReviewerScorecardStatsResponse
 */
export interface GetReviewerScorecardStatsResponse {
    /**
     * 
     * @type {ReviewerScorecardStats}
     * @memberof GetReviewerScorecardStatsResponse
     */
    data?: ReviewerScorecardStats;
    /**
     * 
     * @type {number}
     * @memberof GetReviewerScorecardStatsResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetReviewerScorecardStatsResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetReviewerScorecardStatsResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetReviewerScorecardStatsResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetReviewerScorecardStatsResponse interface.
 */
export function instanceOfGetReviewerScorecardStatsResponse(value: object): boolean {
    return true;
}

export function GetReviewerScorecardStatsResponseFromJSON(json: any): GetReviewerScorecardStatsResponse {
    return GetReviewerScorecardStatsResponseFromJSONTyped(json, false);
}

export function GetReviewerScorecardStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReviewerScorecardStatsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ReviewerScorecardStatsFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetReviewerScorecardStatsResponseToJSON(value?: GetReviewerScorecardStatsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ReviewerScorecardStatsToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

